const normalize = (value) => String(value || "").trim();

const unique = (values) => Array.from(new Set(values.map(normalize).filter(Boolean)));

const PROFILES = {
  bakliyat: [
    ["Yayla Çorbası", "Turşu Tabağı"],
    ["Tarhana Çorbası", "Çoban Salatası"],
    ["Domates Çorbası", "Cacık"],
    ["Şehriye Çorbası", "Mevsim Salatası"],
    ["Sebze Çorbası", "Söğüş Tabağı"],
    ["Ezogelin Çorbası", "Yoğurtlu Semizotu"],
    ["Mercimek Çorbası", "Havuç Tarator"],
    ["Tavuk Suyu Çorbası", "Yeşil Salata"],
  ],
  dolma: [
    ["Mercimek Çorbası", "Cacık"],
    ["Yayla Çorbası", "Mevsim Salatası"],
    ["Tarhana Çorbası", "Haydari"],
    ["Ezogelin Çorbası", "Çoban Salatası"],
    ["Domates Çorbası", "Yoğurtlu Semizotu"],
    ["Şehriye Çorbası", "Söğüş Tabağı"],
    ["Sebze Çorbası", "Havuç Tarator"],
    ["Tavuk Suyu Çorbası", "Yeşil Salata"],
  ],
  sebze: [
    ["Mercimek Çorbası", "Cacık"],
    ["Tarhana Çorbası", "Yoğurtlu Semizotu"],
    ["Ezogelin Çorbası", "Turşu Tabağı"],
    ["Domates Çorbası", "Mevsim Salatası"],
    ["Şehriye Çorbası", "Havuç Tarator"],
    ["Sebze Çorbası", "Haydari"],
    ["Yayla Çorbası", "Söğüş Tabağı"],
    ["Tavuk Suyu Çorbası", "Çoban Salatası"],
  ],
  kofte: [
    ["Mercimek Çorbası", "Piyaz"],
    ["Ezogelin Çorbası", "Çoban Salatası"],
    ["Domates Çorbası", "Cacık"],
    ["Tarhana Çorbası", "Gavurdağı Salatası"],
    ["Şehriye Çorbası", "Mevsim Salatası"],
    ["Sebze Çorbası", "Havuç Tarator"],
    ["Yayla Çorbası", "Turşu Tabağı"],
    ["Tavuk Suyu Çorbası", "Yeşil Salata"],
  ],
  tavuk: [
    ["Domates Çorbası", "Mevsim Salatası"],
    ["Sebze Çorbası", "Cacık"],
    ["Şehriye Çorbası", "Roka Salatası"],
    ["Mercimek Çorbası", "Çoban Salatası"],
    ["Ezogelin Çorbası", "Yoğurtlu Havuç"],
    ["Tarhana Çorbası", "Gavurdağı Salatası"],
    ["Yayla Çorbası", "Yeşil Salata"],
    ["Tavuk Suyu Çorbası", "Havuç Tarator"],
  ],
  et: [
    ["Mercimek Çorbası", "Gavurdağı Salatası"],
    ["Ezogelin Çorbası", "Çoban Salatası"],
    ["Tarhana Çorbası", "Cacık"],
    ["Yayla Çorbası", "Roka Salatası"],
    ["Domates Çorbası", "Söğüş Tabağı"],
    ["Şehriye Çorbası", "Piyaz"],
    ["Sebze Çorbası", "Mevsim Salatası"],
    ["Tavuk Suyu Çorbası", "Turşu Tabağı"],
  ],
  hamurIsi: [
    ["Mercimek Çorbası", "Cacık"],
    ["Domates Çorbası", "Mevsim Salatası"],
    ["Ezogelin Çorbası", "Çoban Salatası"],
    ["Tarhana Çorbası", "Söğüş Tabağı"],
    ["Şehriye Çorbası", "Yoğurtlu Semizotu"],
    ["Sebze Çorbası", "Havuç Tarator"],
    ["Yayla Çorbası", "Yeşil Salata"],
    ["Tavuk Suyu Çorbası", "Turşu Tabağı"],
  ],
  balik: [
    ["Sebze Çorbası", "Roka Salatası"],
    ["Domates Çorbası", "Turplu Roka Salatası"],
    ["Şehriye Çorbası", "Yeşil Salata"],
    ["Mercimek Çorbası", "Mevsim Salatası"],
    ["Ezogelin Çorbası", "Roka Salatası"],
    ["Tarhana Çorbası", "Turplu Roka Salatası"],
    ["Yayla Çorbası", "Yeşil Salata"],
    ["Tavuk Suyu Çorbası", "Mevsim Salatası"],
  ],
  pratik: [
    ["Tarhana Çorbası", "Söğüş Tabağı"],
    ["Mercimek Çorbası", "Cacık"],
    ["Domates Çorbası", "Mevsim Salatası"],
    ["Ezogelin Çorbası", "Çoban Salatası"],
    ["Şehriye Çorbası", "Yoğurtlu Havuç"],
    ["Sebze Çorbası", "Haydari"],
    ["Yayla Çorbası", "Yeşil Salata"],
    ["Tavuk Suyu Çorbası", "Turşu Tabağı"],
  ],
};

const hasAny = (name, terms) => terms.some((term) => name.includes(term));

const profileFor = (dishName) => {
  const name = normalize(dishName).toLocaleLowerCase("tr-TR");

  if (hasAny(name, ["balık", "hamsi", "palamut", "levrek", "çipura", "alabalık", "somon", "uskumru"])) return "balik";
  if (hasAny(name, ["börek", "gözleme", "makarna", "mantı", "erişte", "pide", "lahmacun", "etli ekmek", "içli köfte"])) return "hamurIsi";
  if (hasAny(name, ["menemen", "çılbır", "yumurta", "mercimek köftesi", "kısır"])) return "pratik";
  if (hasAny(name, ["köfte"])) return "kofte";
  if (hasAny(name, ["tavuk"])) return "tavuk";
  if (hasAny(name, ["dolma", "sarma"])) return "dolma";
  if (hasAny(name, ["fasulye", "nohut", "mercimek", "barbunya", "börülce"])) return "bakliyat";
  if (hasAny(name, ["kebap", "kavurma", "tandır", "haşlama", "beğendi", "ali nazik", "çökertme", "etli", "kuzu", "dana", "et sote", "etli güveç", "etli pilav"])) return "et";
  return "sebze";
};

export function buildTurkishMenus(legacyMenus = [], targetCount = 500) {
  const originalMains = legacyMenus.map((menu) => normalize(menu.anaYemek)).filter(Boolean);
  const uniqueMains = unique(originalMains);
  const mainSchedule = originalMains.slice(0, Math.min(originalMains.length, targetCount));

  for (let index = 0; mainSchedule.length < targetCount; index += 1) {
    mainSchedule.push(uniqueMains[index % uniqueMains.length]);
  }

  const usageByMain = new Map();

  return mainSchedule.map((anaYemek, index) => {
    const variant = usageByMain.get(anaYemek) || 0;
    usageByMain.set(anaYemek, variant + 1);
    const pairingProfile = profileFor(anaYemek);
    const pairings = PROFILES[pairingProfile];
    const [corba, salata] = pairings[variant % pairings.length];

    return {
      id: index + 1,
      anaYemek,
      corba,
      salata,
      pairingProfile,
      variant: variant + 1,
      culture: "tr",
    };
  });
}

